// extracted by mini-css-extract-plugin
export default {"SettingsTabContainer":"SettingsTabContainer_SettingsTabContainer__IC055"};